import Component from './value-box';
export default Component;
